import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aum-cli-terms-component',
  templateUrl: './terms-component.component.html',
  styleUrls: ['./terms-component.component.scss']
})
export class TermsComponentComponent {
  pdf = '../../../../assets/test/TERMS AND CONDITIONS 2023.pdf';
  constructor() {}
}
